import React, { lazy } from "react";
import { ScreenKey } from "../../../permissions/screenKeys";

const ProcessInsight = lazy(() => import("./process-insight"));
const RulesConfiguration = lazy(() => import("./rules-configuration"));
const AlertsConfiguration = lazy(() => import("./alerts-configuration"));
const StateConfiguration = lazy(() => import("./state-configuration"));
const CellControllerTuning = lazy(() => import("./cell-controller-tuning"));

const ControlsRoute = () => {
    const routes = [
        {
            key: "rules_configuration",
            path: `/${ScreenKey.RULES_CONFIGURATION}`,
            component: <RulesConfiguration />,
        },
        {
            key: "process_insight",
            path: `/${ScreenKey.PROCESS_INSIGHT}`,
            component: <ProcessInsight />,
        },
        {
            key: "state_action_matrix",
            path: `/${ScreenKey.STATE_ACTION_MATRIX}`,
            component: <StateConfiguration />,
        },
        {
            key: "alerts_configuration",
            path: `/${ScreenKey.ALERTS_CONFIGURATION}`,
            component: <AlertsConfiguration />,
        },
        {
            key: "cell_controller_tuning",
            path: `/${ScreenKey.CELL_CONTROLLER_TUNING}`,
            component: <CellControllerTuning />,
        },
    ];

    return routes;
};

export default ControlsRoute;
